import * as moment from 'moment';
export class AreaGraphOption {
  /* Graph Chart Config Elements */
  static graphLoader =
    '<div class="ces-loader ces-spin-card-loader ces-loader-md"><span class="ces-spinner ces-loader-size graph-spinner"></span></div>';

  static nodataObj: any = {
    position: {
      align: 'center',
    },
    style: {
      fontSize: '15px',
      fontWeight: 'normal',
    },
  };

  static yAxis = {
    gridLineWidth: 1,
    gridLineDashStyle: 'longdash',
    gridLineColor: 'var(--chart-dashed-line)',
    lineColor: 'var(--chart-dashed-line)',
    title: {
      text: 'Values',
      style: {
        color: 'var(--legend-color)',
      },
    },
    labels: {
      style: {
        color: 'var(--legend-color)',
      },
    },
    lineWidth: 1,
  };

  static xAxis = {
    gridLineWidth: 1,
    gridLineDashStyle: 'longdash',
    type: 'datetime',
    color: 'var(--text-color-dark)',
    gridLineColor: 'var(--chart-dashed-line)',
    lineColor: 'var(--chart-dashed-line)',
    tickColor: 'var(--chart-dashed-line)',
    title: {
      text: 'Time',
      style: {
        color: 'var(--legend-color)',
      },
    },

    labels: {
      formatter: function () {
        return moment.unix(this['value']).local().add(1, 'day').format('MMM D');
      },
      rotation: 0,
      style: {
        color: 'var(--legend-color)',
      },
    },
    lineWidth: 1,
  };

  static plotOptions = {
    area: {
      lineColor: 'rgb(63, 89, 228)',
      lineWidth: 2,
    },
  };

  static legend = {
    align: 'right',
    shadow: false,
    fontWeight: '400',
    fontSize: '12px',
    itemStyle: {
      color: 'var(--legend-color)',
    },
    itemHoverStyle: {
      color: 'var(--legend-color)',
    },
    itemHiddenStyle: {
      color: '#444',
    },
  };

  static noData: any = {
    position: {
      align: 'center',
    },
    style: {
      fontSize: '15px',
      fontWeight: 'normal',
      color: 'var(--tag-title)',
      fill: 'var(--tag-title)',
    },
  };

  static loading: any = {
    hideDuration: 300,
    showDuration: 500,
    style: {
      backgroundColor: 'var(--card-bg)',
    },
    labelStyle: { top: '35%' },
  };

  static chartExport: any = {
    chart: {
      backgroundColor: '#ffffff',
      marginRight: 50,
    },
    yAxis: {
      gridLineColor: '#e6e6e6',
      lineColor: '#ccd6eb',
      tickColor: '#ccd6eb',
      lineWidth: 1,
      gridLineWidth: 0.5,
    },
    xAxis: {
      gridLineColor: '#e6e6e6',
      lineColor: '#ccd6eb',
      tickColor: '#ccd6eb',
      lineWidth: 1,
      gridLineWidth: 0.5,
    },
  };

  static commonObj: any = {
    lang: {
      noData: 'No data available',
    },
    title: {
      text: null,
    },
    time: {
      useUTC: false,
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    noData: { ...AreaGraphOption.noData },
    loading: AreaGraphOption.loading,
  };
  public static TOOLTIP: any = {
    formatter: function () {
      return (
        moment.unix(this['x']).local().format('MMM D, YYYY') +
        '<br/>' +
        ' ' +
        this['series']['name'] +
        ' : ' +
        this['y'].toFixed(2)
      );
    },
    valueDecimals: 2,
  };
  static LINE_CHART_DEFAULT: any = {
    ...AreaGraphOption.commonObj,
    chart: {
      height: 250,
      zoomType: 'x',
      type: 'line',
      backgroundColor: 'var(--card-bg)',
    },
    xAxis: AreaGraphOption.xAxis,
    yAxis: AreaGraphOption.yAxis,
    plotOptions: {
      area: {
        lineColor: 'rgb(63, 89, 228)',
      },
      series: {
        lineWidth: 2,
        color: 'var(--card-bg)',
        marker: {
          enabled: false,
        },
      },
    },
  };

  public static WIND_CHART: any = {
    ...AreaGraphOption.LINE_CHART_DEFAULT,
    series: [
      {
        showInLegend: false,
        data: [],
        name: '',
        fillOpacity: 0.3,
        animation: true,
        color: 'rgb(63, 89, 228)',
      },
    ],
  };
}
